import moment from "moment";

export const checkDate = (date: moment.MomentInput | null | undefined, dateFormat = "L"): string | undefined => {
  if (date === null) {
    return;
  }

  if (typeof date === "undefined") {
    return;
  }

  if (moment(date).isValid()) {
    return moment.utc(date).format(dateFormat);
  }
};
